import request from '@/utils/request';

export function fetchDocumentList(params) {
  return request({
    url: `/enterprise-server/documents`,
    method: 'get',
    params
  });
}

export function fetchDocumentDeatil(params) {
  return request({
    url: `/enterprise-server/documents/${params.docID}`,
    method: 'get'
  });
}

export function deleteDocument(params) {
  return request({
    url: `/enterprise-server/documents/${params.docID}`,
    method: 'delete'
  });
}

export function createDocument(params) {
  return request({
    url: `/enterprise-server/documents`,
    method: 'post',
    data: params
  });
}
export function updateDocument(params) {
  return request({
    url: `/enterprise-server/documents/${params.docID}`,
    method: 'put',
    data: params
  });
}



// WEBPACK FOOTER //
// ./src/api/document.js